import React from 'react';
import { RoomContext } from '@livekit/components-react';
import { ConversationProps } from './types';
import { useRoomConnection } from './hooks';
import { ConversationContent } from './components';

export const MonitorConversationListV2: React.FC<ConversationProps> = ({
  phoneNumber = 'You',
  startCallTime,
  call,
  onError,
}: ConversationProps) => {
  const { room, isRoomConnected } = useRoomConnection(call.id, call.status, onError);

  return (
    <RoomContext.Provider value={room}>
      <ConversationContent
        call={call}
        phoneNumber={phoneNumber}
        startCallTime={startCallTime}
        onError={onError}
        isRoomConnected={isRoomConnected}
      />
    </RoomContext.Provider>
  );
};
